<template>
  <div>
    <table class="table w-full mb-3">
      <thead>
        <tr>
          <th v-text="$t('send_image')"></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <div class="vx-row">
              <div class="vx-col w-full mb-3">
                <div class="text-danger">
                  <p style="font-weight: bold;">사진 업로드 유의 사항.</p>
                  <ul>
                    <li class="ml-3">• 1000 X 1000 px 이하</li>
                    <li class="ml-3">• 용량 : 개당 500KB 이하</li>
                    <li class="ml-3">• JPG (RGB COLOR) 형식</li>
                    <li class="ml-3">• 1회 최대 3개의 이미지 발송 가능</li>
                  </ul>
                </div>
              </div>

              <div class="vx-col sm:w-1/3 md:w-1/3 w-full">
                <base-image-input v-model="sendImage.file1" @change="update"/>
              </div>
              <!--
              <div class="vx-col sm:w-1/3 md:w-1/3 w-full">
                <base-image-input v-model="sendImage.file2" @change="update"/>
              </div>
              <div class="vx-col sm:w-1/3 md:w-1/3 w-full">
                <base-image-input v-model="sendImage.file3" @change="update"/>
              </div>
              -->
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import BaseImageInput from '@/components/form-inputs/BaseImageInput'

export default {
  name: 'ImageForm',
  components: {
    BaseImageInput
  },
  data () {
    return {
      sendImage: {
        file1: null,
        file2: null,
        file3: null
      }
    }
  },
  methods: {
    update () {
      this.$emit('input', this.sendImage)
    }
  }
}
</script>

<style>
.send-message-container .vs-textarea {
  resize: vertical !important;
  min-height: 230px;
}
</style>
